/* eslint-disable no-case-declarations */
import actions from "./actions";

const {
  LIST_EMPLOYEES_BEGIN,
  LIST_EMPLOYEES_SUCCESS,
  LIST_EMPLOYEES_ERR,

  CREATE_EMPLOYEE_BEGIN,
  CREATE_EMPLOYEE_SUCCESS,
  CREATE_EMPLOYEE_ERR,

  UPDATE_EMPLOYEE_BEGIN,
  UPDATE_EMPLOYEE_SUCCESS,
  UPDATE_EMPLOYEE_ERR,

  DELETE_EMPLOYEE_BEGIN,
  DELETE_EMPLOYEE_SUCCESS,
  DELETE_EMPLOYEE_ERR,

  BLOCK_EMPLOYEE_BEGIN,
  BLOCK_EMPLOYEE_SUCCESS,
  BLOCK_EMPLOYEE_ERR,

  UNBLOCK_EMPLOYEE_BEGIN,
  UNBLOCK_EMPLOYEE_SUCCESS,
  UNBLOCK_EMPLOYEE_ERR,

  GET_EMPLOYEE_DETAILS_BEGIN,
  GET_EMPLOYEE_DETAILS_SUCCESS,
  GET_EMPLOYEE_DETAILS_ERR,
} = actions;

const initState = {
  loadingCreateEmployee: false,
  errorCreateEmployee: "",
  loadingUpdateEmployee: false,
  errorUpdateEmployee: "",
  employees: [],
  totalEmployees: 0,
  totalEmployeesPages: 0,
  loadingDeleteEmployee: false,
  errorDeleteEmployee: "",
  loadingBlockEmployee: false,
  errorBlockEmployee: null,
  loadingUnblockEmployee: false,
  errorUnblockEmployee: null,
  loadingGetEmployeeDetails: false,
  errorGetEmployeeDetails: null,
  employeeDetails: {},
};

const employeesReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case CREATE_EMPLOYEE_BEGIN:
      return {
        ...state,
        loadingCreateEmployee: true,
        errorCreateEmployee: "",
      };
    case CREATE_EMPLOYEE_SUCCESS:
      return {
        ...state,
        employees: [...state.employees, data],
        loadingCreateEmployee: false,
        errorCreateEmployee: "",
      };
    case CREATE_EMPLOYEE_ERR:
      return {
        ...state,
        errorCreateEmployee: err,
        loadingCreateEmployee: false,
      };

    case LIST_EMPLOYEES_BEGIN:
      return {
        ...state,
        loadingListEmployees: true,
        errorListEmployees: false,
        totalEmployees: 0,
        totalEmployeesPages: 0,
      };
    case LIST_EMPLOYEES_SUCCESS:
      return {
        ...state,
        employees: [...data.results],
        loadingListEmployees: false,
        errorListEmployees: null,
        totalEmployees: data.total_count,
        totalEmployeesPages: data.total_pages,
      };
    case LIST_EMPLOYEES_ERR:
      return {
        ...state,
        errorListEmployees: err,
        loadingListEmployees: false,
        totalEmployees: 0,
        totalEmployeesPages: 0,
      };

    case UPDATE_EMPLOYEE_BEGIN:
      return {
        ...state,
        loadingUpdateEmployee: true,
        errorUpdateEmployee: false,
      };
    case UPDATE_EMPLOYEE_SUCCESS:
      const updatedEmployees = state.employees.map((employee) =>
        employee.id === data.id ? { ...employee, ...data } : employee
      );
      return {
        ...state,
        employees: updatedEmployees,
        loadingUpdateEmployee: false,
        errorUpdateEmployee: null,
      };
    case UPDATE_EMPLOYEE_ERR:
      return {
        ...state,
        errorUpdateEmployee: err,
        loadingUpdateEmployee: false,
      };

    case DELETE_EMPLOYEE_BEGIN:
      return {
        ...state,
        loadingDeleteEmployee: true,
        errorDeleteEmployee: null,
      };
    case DELETE_EMPLOYEE_SUCCESS:
      return {
        ...state,
        employees: state.employees.filter(
          (employee) => employee.id !== data.id
        ),
        loadingDeleteEmployee: false,
        errorDeleteEmployee: null,
      };
    case DELETE_EMPLOYEE_ERR:
      return {
        ...state,
        errorDeleteEmployee: err,
        loadingDeleteEmployee: false,
      };

    case BLOCK_EMPLOYEE_BEGIN:
      return {
        ...state,
        loadingBlockEmployee: true,
        errorBlockEmployee: null,
      };
    case BLOCK_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loadingBlockEmployee: false,
        errorBlockEmployee: null,
      };
    case BLOCK_EMPLOYEE_ERR:
      return {
        ...state,
        errorBlockEmployee: err,
        loadingBlockEmployee: false,
      };

    case UNBLOCK_EMPLOYEE_BEGIN:
      return {
        ...state,
        loadingUnblockEmployee: true,
        errorUnblockEmployee: null,
      };
    case UNBLOCK_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loadingUnblockEmployee: false,
        errorUnblockEmployee: null,
      };
    case UNBLOCK_EMPLOYEE_ERR:
      return {
        ...state,
        loadingUnblockEmployee: false,
        errorUnblockEmployee: err,
      };

    case GET_EMPLOYEE_DETAILS_BEGIN:
      return {
        ...state,
        employeeDetails: {},
        loadingGetEmployeeDetails: true,
        errorGetEmployeeDetails: null,
      };
    case GET_EMPLOYEE_DETAILS_SUCCESS:
      return {
        ...state,
        employeeDetails: data,
        loadingGetEmployeeDetails: false,
        errorGetEmployeeDetails: null,
      };
    case GET_EMPLOYEE_DETAILS_ERR:
      return {
        ...state,
        employeeDetails: {},
        loadingGetEmployeeDetails: false,
        errorGetEmployeeDetails: err,
      };

    default:
      return state;
  }
};

export { employeesReducer };
